import { assertInInjectionContext, inject, Injector, runInInjectionContext } from '@angular/core';
import { StorageService } from '@techniek-team/storage';
import { from, map, Observable, pipe, switchMap, UnaryFunction } from 'rxjs';
import { LoggerWithConfigurationService } from '../service/internal/logger-with-configuration.service';
import { createPrefixMessage } from './prefix-message.function';

export const checkIfRefreshIsAlreadyRunning = (
  injector?: Injector,
): UnaryFunction<Observable<unknown>, Observable<boolean>> => {
  if (!injector) {
    assertInInjectionContext(checkIfRefreshIsAlreadyRunning);
    injector = inject(Injector);
  }
  return runInInjectionContext(injector, () => {
    const prefixMessage = createPrefixMessage('checkIfRefreshIsAlreadyRunning');
    const storage = inject(StorageService);
    const loggerService = inject(LoggerWithConfigurationService);
    return pipe(
      switchMap(() =>
        from(storage.get('oauth/refresh-process-running')).pipe(
          map((lockId) => {
            const isAlreadyRunning = !!lockId;
            if (isAlreadyRunning) {
              loggerService.logDebug(
                prefixMessage(`The refresh process is already running. [lockId: ${lockId}]`),
              );
            } else {
              loggerService.logDebug(
                prefixMessage(
                  `The refresh process is not running. Starting the refresh process...`,
                ),
              );
            }

            return isAlreadyRunning;
          }),
        ),
      ),
    );
  });
};
